module.exports = __webpack_public_path__ + "static/media/camera.dce0ddc2.svg";